import { render, staticRenderFns } from "./MarketingComponent.vue?vue&type=template&id=6434caf5&scoped=true&"
import script from "./MarketingComponent.vue?vue&type=script&lang=js&"
export * from "./MarketingComponent.vue?vue&type=script&lang=js&"
import style0 from "./MarketingComponent.vue?vue&type=style&index=0&id=6434caf5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6434caf5",
  null
  
)

export default component.exports